import { get as GetValueByPath } from 'lodash';

import React, { useState, useEffect } from 'react';
import { TextInput, MarkupProps, useFormContext } from 'blueprint-form';

export const REGEX_PASS_STRENGTH =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!?&%$*]).{8,32}$/;
export const REGEX_PASS_LENGTH = /^.{8,32}$/i;
export const REGEX_PASS_UPPER_LOWER = /(?=.*[a-z])(?=.*[A-Z])/;
export const REGEX_PASS_NUMBER = /(?=.*\d)/i;
export const REGEX_PASS_SYMBOL = /(?=.*[!?&%$*])/i;

export const PasswordStrength: React.FC<{ password: string }> = ({
  password
}) => {
  const [isLengthMet, setIsLengthMet] = useState(false);
  const [isCaseMet, setIsCaseMet] = useState(false);
  const [isNumberMet, setIsNumberMet] = useState(false);
  const [isSymbolMet, setIsSymbolMet] = useState(false);
  useEffect(() => {
    setIsLengthMet(REGEX_PASS_LENGTH.test(password));
    setIsCaseMet(REGEX_PASS_UPPER_LOWER.test(password));
    setIsNumberMet(REGEX_PASS_NUMBER.test(password));
    setIsSymbolMet(REGEX_PASS_SYMBOL.test(password));
  }, [password]);
  const metStyle = { color: '#52C41A' };
  return (
    <ul className="mb-4">
      <li style={isLengthMet ? metStyle : null}>
        Must be 8 - 32 characters long
      </li>
      <li style={isCaseMet ? metStyle : null}>
        Contains a lower and upper case character
      </li>
      <li style={isNumberMet ? metStyle : null}>Contains a number</li>
      <li style={isSymbolMet ? metStyle : null}>
        Contains a symbol: ! ? & % $ *
      </li>
    </ul>
  );
};

interface PasswordInputProps extends MarkupProps {
  showStrength?: boolean;
  enforceStrength?: boolean;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  showStrength,
  enforceStrength,
  ...props
}) => {
  const { values } = useFormContext();
  const password = GetValueByPath(values, props.name);
  return (
    <>
      <TextInput
        pattern={enforceStrength ? REGEX_PASS_STRENGTH : null}
        {...props}
        type="password"
      />
      {showStrength && <PasswordStrength password={password} />}
    </>
  );
};

export default PasswordInput;
